export default async function PerdasGraficoExtraRelatorio(
    content,
    h,
    mediaAgrupadorList,
    metaUsar,
    IndicadorEntity,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
) {
    content.push(
        h.panel(
            [
                h.row(
                    await h.chart(
                        "PieChart",
                        {
                            xField: "groupNameShow",
                            yField: "media",
                            data: mediaAgrupadorList,
                            meta: parseFloat(metaUsar),
                            width: 525,
                            height: 400,

                            // usado no indicador perdas
                            IndicadorClass: IndicadorEntity,
                            agrupador: groupByConfig,
                            apontamentos: apontamentos,
                            mediaAgrupadorList: mediaAgrupadorList,
                            paramsCliente: paramsCliente
                        },
                        { alignment: "center" }
                    ),
                ),
            ],
            { widths: ["*"], unbreakable: true, layout: "borders" }
        )
    )
}